// Terminal color themes

export interface Theme {
	name: string;
	primary: string;
	secondary: string;
	accent: string;
	bg: string;
	bgLight: string;
	text: string;
	textMuted: string;
}

export const THEMES: Record<string, Theme> = {
	matrix: {
		name: 'Matrix',
		primary: '#4ACB85',
		secondary: '#3a9f6a',
		accent: '#00ff00',
		bg: '#0a0a0a',
		bgLight: '#111111',
		text: '#4ACB85',
		textMuted: '#4ACB8580'
	},
	amber: {
		name: 'Amber',
		primary: '#ffb000',
		secondary: '#cc8800',
		accent: '#ff6600',
		bg: '#0a0800',
		bgLight: '#151208',
		text: '#ffb000',
		textMuted: '#ffb00080'
	},
	cyan: {
		name: 'Cyan',
		primary: '#00ffff',
		secondary: '#008888',
		accent: '#ff00ff',
		bg: '#000a0a',
		bgLight: '#001515',
		text: '#00ffff',
		textMuted: '#00ffff80'
	},
	synthwave: {
		name: 'Synthwave',
		primary: '#ff00ff',
		secondary: '#00ffff',
		accent: '#ffff00',
		bg: '#0a0010',
		bgLight: '#150020',
		text: '#ff00ff',
		textMuted: '#ff00ff80'
	},
	hacker: {
		name: 'Hacker',
		primary: '#00ff41',
		secondary: '#008f11',
		accent: '#ff0000',
		bg: '#000000',
		bgLight: '#0d0d0d',
		text: '#00ff41',
		textMuted: '#00ff4180'
	}
};

export type ThemeName = keyof typeof THEMES;
export const DEFAULT_THEME: ThemeName = 'matrix';

const STORAGE_KEY = 'ameta-terminal-theme';

export function loadTheme(): ThemeName {
	if (typeof window !== 'undefined') {
		const saved = localStorage.getItem(STORAGE_KEY) as ThemeName;
		if (saved && THEMES[saved]) {
			return saved;
		}
	}
	return DEFAULT_THEME;
}

export function saveTheme(theme: ThemeName): void {
	if (typeof window !== 'undefined') {
		localStorage.setItem(STORAGE_KEY, theme);
	}
}
